var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    : _c("div", { staticClass: "box", attrs: { id: "management" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-4" },
            [
              _c("h4", [_vm._v("Contracts")]),
              _vm._v(" "),
              _vm._l(_vm.contractList, function(contract, index) {
                return _c(
                  "form",
                  {
                    key: index,
                    attrs: { id: "contract-form-" + index },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.updateContract(index)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "form-row" }, [
                        _c("div", { staticClass: "col" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.contractList[index],
                                expression: "contractList[index]"
                              }
                            ],
                            staticClass: "form-control details-input",
                            class: _vm.getSavingClass("contract-" + index),
                            attrs: {
                              type: "text",
                              id: "contract-" + index,
                              required: ""
                            },
                            domProps: { value: _vm.contractList[index] },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.contractList,
                                  index,
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col" }, [
                          _c("button", { staticClass: "btn btn-primary" }, [
                            _vm._v("Save")
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-danger",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.deleteContract(index)
                                }
                              }
                            },
                            [_vm._v("Delete")]
                          )
                        ])
                      ])
                    ])
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.addContract()
                      }
                    }
                  },
                  [_vm._v("Add Contract")]
                )
              ])
            ],
            2
          )
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c656b962", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c656b962","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/GroupModify.vue
// module id = null
// module chunks = 